import React, { useEffect, useRef, useState } from 'react-x';
import propTypes from 'prop-types-x';
import classNames from 'classnames';
import { BackgroundMedia } from './BackgroundMedia.jsx';
import { LoadingCharacters } from './LoadingCharacters.jsx';
import { CssAnimation } from './CssAnimation.jsx';
import { fitToScreen } from '../../utilities/fitToScreen.js';
import { MEDIA_TYPES } from '../../constants/config.js';

export function LoadingScreen(props) {

  const { 
    text,
    onLoadingCompletionCallback, 
    loadingConditionsComplete, 
    videoUrl,
    loopVideo,
    backgroundCover
  } = props;

  const [loadingAnimationFinished, setLoadingAnimationFinished] = useState(false);
  const [transitionOut, setTransitionOut] = useState(false);
  const rootElRef = useRef();
  const fitToScreenRef = useRef();
  const block = 'c-loading-screen';

  const videoConfig = {
    onEnded: e => { 
      const videoEl = e.target;
      if (loopVideo && !loadingConditionsComplete) {
        videoEl.play();
      } else {
        setLoadingAnimationFinished(true);
      }
    },
    loop: false
  };

  useEffect(() => {
    fitToScreenRef.current = fitToScreen(rootElRef.current, [document.querySelector('.header')])
    fitToScreenRef.current.init();

    return () => {
      fitToScreenRef.current.destroy();
    }
  }, []);

  useEffect(() => {
    if (loadingConditionsComplete && loadingAnimationFinished) {
      setTransitionOut(true);
    }
  }, [loadingConditionsComplete, loadingAnimationFinished]);

  return (
    <div 
    ref={rootElRef}
    className={classNames({
      [block]: true,
      [`${block}__background-contain`]: !backgroundCover
    })} 
    >
      <CssAnimation
      enter={{ name: 'fade-in', duration: 1.5 }}
      exit={{ name: 'fade-out', duration: 0.5 }}
      triggerEnter={!transitionOut}
      triggerExit={transitionOut}
      onExitEnd={onLoadingCompletionCallback}
      renderView={!!videoUrl}
      >
        <div>
          <BackgroundMedia
          mediaType={MEDIA_TYPES.video}
          mediaUrl={videoUrl}
          videoConfig={videoConfig}
          />
          { 
            text && 
              <h5 className={`${block}__loading-text`}>
                { text } 
                <LoadingCharacters classes='h5' />
              </h5>
          }
        </div>
      </CssAnimation>
    </div>
  )
};

LoadingScreen.propTypes = {
  onLoadingCompletionCallback: propTypes.func,
  loadingConditionsComplete: propTypes.bool,
  videoUrl: propTypes.string,
  loopVideo: propTypes.bool,
  backgroundCover: propTypes.bool
}; 

LoadingScreen.defaultProps = {
  loopVideo: false,
  backgroundCover: true
};